import { Heading } from '@components/gassan-ui/Typography/Heading'
import { CbHtmlEmbed } from '@lib/kontent/models/CbHtmlEmbed'
import { FC } from 'react'
import { cn } from '@lib/cn'

type DigitalProductListProps = {
  title: string
  items: CbHtmlEmbed[]
}

export const DigitalProductList: FC<DigitalProductListProps> = ({ title, items }) => {
  return (
    <section>
      <Heading variant="h3" as="h2" className={cn('mb-4', 'md:mb-6')}>
        {title}
      </Heading>
      <ul className={cn('block', 'md:grid md:grid-cols-2 md:gap-4', 'lg:gap-8')}>
        {items.map((item, key) => (
          <div
            key={key}
            className="w-full"
            dangerouslySetInnerHTML={{ __html: item.html_content.value }}
          />
        ))}
      </ul>
    </section>
  )
}
